import React from "react";
import useHover from "../hooks/useHover";
import DetailedButton from "./DetailedButton";

const SideButton = ({
  name,
  object,
  onButtonClicked,
  type,
  fontSize = 17,
  backgroundColor = "#5f5f5f",
  width = "60%",
}) => {
  return (
    <div
      className="divRow"
      style={{
        justifyContent: "center",
        height: "100%",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      {!object && (
        <DetailedButton
          id={object?.id}
          onButtonClicked={onButtonClicked}
          name={name}
          description={`${name} ${type}`}
          fontSize={fontSize}
          backgroundColor={backgroundColor}
          width={width}
        />
      )}
      {object && <ObjectFoundField type={type} name={name} width={width} />}
    </div>
  );
};

const ObjectFoundField = ({ type, name, width = "50%" }) => {
  const obj = {
    Open: "opened",
    Save: "saved",
  };
  return (
    <div
      className="divRow"
      style={{
        border: "4px solid #8f8f8f",
        padding: "2px",
        height: "80%",
        width: width,
        marginTop: "10px",
        backgroundColor: "#6f6f6f",
        justifyContent: "center",
      }}
    >
      <div
        className="textBoldWhite"
        style={{ marginRight: "10px", color: "#9f9f9f" }}
      >
        {type}
      </div>
      <div className="textBoldWhite" style={{ color: "#9f9f9f" }}>
        {name == "Open" ? "opened" : "saved"}
      </div>
    </div>
  );
};

export default SideButton;
